var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarsvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.88965,
    y: 8.10645,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66309,
    y: 8.10645,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.43628,
    y: 8.10645,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.21,
    y: 8.10645,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.88965,
    y: 11.5195,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66309,
    y: 11.5195,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.43652,
    y: 11.5195,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12.21,
    y: 11.5195,
    width: 1.70667,
    height: 1.70667,
    fill: "#E52333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_9749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9033 2H14.2367V0.666626C14.2367 0.298706 13.938 0 13.5699 0H12.9033C12.5353 0 12.2367 0.298706 12.2367 0.666626V2H5.56995V0.666626C5.56995 0.298706 5.27136 0 4.90332 0H4.23669C3.86865 0 3.56995 0.298706 3.56995 0.666626V2H2.90332C1.80066 2 0.90332 2.89734 0.90332 4V14C0.90332 15.1027 1.80066 16 2.90332 16H14.9033C16.006 16 16.9033 15.1027 16.9033 14V4C16.9033 2.89734 16.006 2 14.9033 2ZM15.5699 14C15.5699 14.3673 15.2706 14.6666 14.9033 14.6666H2.90332C2.53601 14.6666 2.23669 14.3673 2.23669 14V6.69336H15.5699V14Z",
    fill: "#E52333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_9749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.90332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarsvg);
export default __webpack_public_path__ + "static/media/calendarsvg.9d1b6b75c308aa37b1dadb81fe22faf2.svg";
export { ForwardRef as ReactComponent };